<template>
    <BaseNew @new-confirm-action="createEntry" @new-cancel-action="resetForm" @new-open-action="loadServerEntry"
        @clear-form-errors="clearFormErrors" ref="baseNew" width="70%" :formErrors="formErrors" :loading="loading"
        :pageLoading="pageLoading" :modelNameSingular="modelNameSingular" :inlineAddButton="inlineAddButton">
        <template slot="newForm">
            <Form ref="form" :entry="entry" :extraData="extraData" :modelNameSingular="modelNameSingular" />
        </template>
    </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
    data() { return { loading: true, pageLoading: false, entry: null, formErrors: [], extraData: null }; },
    props: { inlineAddButton: { type: Boolean, default: false }, modelNameSingular: String },
    components: { Form, BaseNew },
    methods: {
        loadServerEntry() {
            this.loading = true;
            this.$apollo.query({ query: LOAD_NEW_LABEL, fetchPolicy: "no-cache" }).then(response => {
                this.entry = response.data.accountContext.label;
                this.extraData = response.data;
            }).catch(response => console.log(response)).finally(() => (this.loading = false));
        },
        createEntry() {
            if (!this.$refs.form.isFormValid()) return;
            this.pageLoading = true;
            this.$apollo.mutate({
                mutation: CREATE_LABEL,
                variables: { input: this.deepFilterEntryWithAllowedFieldsForMutation(this.entry, this.entry.validations) }
            }).then(response => {
                const errors = response.data.createLabel.errors;
                if (errors.length) this.formErrors = errors;
                else { this.$refs.baseNew.closeDialog(); this.$emit("entry-created", response.data.createLabel.label); this.resetForm(); }
            }).catch(response => console.log(response)).finally(() => (this.pageLoading = false));
        },
        resetForm() { if (this.$refs.form) this.$refs.form.resetFormInputs(); this.formErrors = []; },
        clearFormErrors() { this.formErrors = []; }
    }
};

const LOAD_NEW_LABEL = gql`
{ 
    accountContext
    { 
        label 
        { 
                description
                labelType
                colorId
                validations
        } 
    }
    globalContext 
    { 
        allColors 
        { id name hexaCode } 
        allLabelTypes {
            text
            value
        }
    } 
}`;
const CREATE_LABEL = gql`mutation($input: LabelCreateInputObject!) { createLabel(input: $input) { label { id description labelType } errors } }`;
</script>

<style scoped></style>